// This file contains game wrapper type definitions
// The shared state object is at the bottom of this file

import {
    IUserdataType,
    ILanguageType,
    VideoQualityType,
    IGameObjectType,
    ITimerObjectType,
    IGameType,
    ITimerType,
    IKeyNumberDict,
	IKeyStringArrayDict,
} from "@/types/GlobalTypes";

import {
    ITransactionHistoryType
} from "@/types/TransactionTypes";

import {
    INewsType
} from "@/types/NewsTypes";

import { ISettings } from "./settings";

import { ITransactionHistoryState } from "./transactions";


//Todo: move all shared state here
export interface ISharedGameWrapperState extends ISettings, ITransactionHistoryState {
    enableTimers: boolean,
    useTempData: boolean,

    userdata: IUserdataType;
    lang: ILanguageType;

    // Debugging flags
    logSocketEvents: boolean;
    logBaccaratScanEvent: boolean;
    logDTScanEvent: boolean;
    logNNScanEvent: boolean;
    logLottoScanEvent: boolean;

    // Chip selector active value
    chipValue: number;

    //Insufficient balance indicator
    insufficientBalance: boolean;

    // Video quality support
    activeVideoQuality: VideoQualityType;
}

// TYPESCRIPT INTERFACES
export interface IDesktopState extends ISharedGameWrapperState {
    // Game list and favourited pcodes
    games: IGameObjectType;
    timers: ITimerObjectType;
    news: INewsType;

    // Error Handling
    showErrorPage: boolean;
    errorType: string;
    errorMessage: string;

    // Check fetchFavourites()
    // Check toggleFavourite(e: attribute pcode) to set
    favouritedGames: string[];

    // Game-related types
    maximisedGamePcode: string;
    activeGameCount: number; // useful to count collection of active games
    activeGamePcodes: string[]; // useful to track maximising and restoring

    activeGame: IGameType;

	/**
	 * Used in how to play
	 */
    uniqueGamePcodes: string[];

	/**
	 * Used in desktop lobby & header game list & also mobile lobby
	 */
	gameGroups: IKeyStringArrayDict;
    fastTableGames: string[];

    activeGameGroup: string;

    // to check fullscreen
    isFullscreen: boolean;
    allowFullscreen: boolean;
    // to check maingame just once
    hasLoadedMainGame: boolean;
    // in Lobby: enables game logo animation and shows Play Now button
    activeHover: string;

    // How to Play component
    showHowToPlay: boolean;
    howToPlayGamePcode: string;
    howToPlayPcode: string;
    showHowToPlayDropdown: boolean;

    gameResultHistoryPage: number;
    showGameResultHistoryLoadingOverlay: boolean;

    transactionHistoryData: ITransactionHistoryType;
    transactionHistoryPage: number;
    showTransactionHistoryLoadingOverlay: boolean;


    // Game Filter
    lobbyGameFilter: string;

    // Show all history
    showLobbyHistory: boolean;
    showLobbyRoadmap: boolean;

    // PopupResultHistory component
    showInfoNews: boolean;

    showResultHistory: boolean;

    // Settings component
    showSettingsPopup: boolean;

    defaultEnableStreaming: boolean;

    showLobbyGameGroup: boolean;

    // Applying default settings
    isLoadingStreaming: boolean;

    baccaratDarkMode: boolean;

    // For Baccarat and Dragon & Tiger
    completeTable: boolean;

    // For Hidden Roadmap (m25)
    showHiddenRoadmap: boolean;

    // For RaceBall (m26)
    activeTicketIndexM26: number;

	/**
	 * Automatically hides header when active
	 * (original state is in DesktopHeader)
	 */
    autoHideHeader: boolean;

    // Mandatory for PopupResultHistory
    portraitTabIndex: number;
}


export interface IMobileLobbyState extends ISharedGameWrapperState {
    enableTimers: boolean;
    useTempData: boolean;

    games: IGameObjectType;

	/**
	 * for PopupResultHistory
	 */
    activeGame: IGameType;
    userdata: IUserdataType;
    lang: ILanguageType;
    timers: ITimerObjectType;

    orientation: string;

    isFullscreen: boolean;

    //Game Group
    showLobbyGameGroup: boolean;
    lobbyGameFilter: string;

	/**
	 * for how to play
	 */
    uniqueGamePcodes: string[];
	gameGroups: IKeyStringArrayDict;

    activeGameGroup: string;

    showSidebar: boolean;
    showAllHistory: boolean;
    showAllRoadmap: boolean;
    showCategories: boolean;
    activeHover: string;
    favouritedGames: string[];

    //Result History Popup
    showGameResultHistoryPopup: boolean;
    gameResultHistoryPage: number;
    showGameResultHistoryLoadingOverlay: boolean;
    portraitTabIndex: number;

    //How to Play
    showHowToPlay: boolean;
    showHowToPlayDropdown: boolean;
    howToPlayPcode: string;

    fastTableGames: string[];

    showErrorPage: boolean;
    errorType: string;
    errorMessage: string;

    activeVideoQuality: VideoQualityType;
}

export interface IMaximizeMobileGameState extends ISharedGameWrapperState {
    activeGame: IGameType;
    activeTimer: ITimerType;

    winAmount: number;

    //For iOS fake fullscreen height check
    enableScreenHeightPolling: boolean;

    //Toggleable in-game
    showLeftPane: boolean;

    //check componentDidMount()
    v3: boolean;
    v4: boolean;
    toto: boolean;

    games: IGameObjectType;
    timers: ITimerObjectType;

    // For Chip Deck
    chipValue: number;

    //Todo: disable all isFullscreen
    //Android API supports fullscreen while iOS doesn't
    isFullscreen: boolean;

    //Settings panel
    showSettings: boolean;

    showRoadmap: boolean;
    showHistory: boolean;
    showStatistics: boolean;
    showMinMax: boolean;

    showBurgerMenu: boolean;

    showHowToPlay: boolean;
    showHowToPlayDropdown: boolean;

    showGameResultHistoryLoadingOverlay: boolean;
    gameResultHistoryPage: number;

    showTransactionHistoryPopup: boolean;
    showTransactionHistoryLoadingOverlay: boolean;
    transactionHistoryData: any;
    transactionHistoryPage: number;

    roadmapFilters: string[];
    activeRoadmapFilter: string;

    //BC & DT
    tieAnimation: any;
    bankerWinAnimation: any;
    playerWinAnimation: any;


    //Orientation event detection
    orientation: "portrait" | "landscape";

    //Any socket.io errors
    connectionLostError: boolean;

    //For settings
    showSettingsPopup: boolean;

    //For Streaming
    isLoadingStreaming: boolean;

    //Only for baccarat
    roadmapExpanded: boolean;

    //For Baccarat; Dragon & Tiger; FanTan
    completeTable: boolean;

    //For RaceBall (m26)
    activeTicketIndexM26: number;

    //For Result History popups
    showGameResultHistoryPopup: boolean;
    portraitTabIndex: number;

    winNumberGif: any;
    winNumberGifs: any[];

    howToPlayPcode: string;
    uniqueGamePcodes: string[];

    //For Internal Error check
    showErrorPage: boolean;
    errorType: string;
    errorMessage: string;

    //For Testing Purposes
    availWidth: number;
    availHeight: number;
    innerWidth: number;
    innerHeight: number;

    iOSInnerHeight: number;

    //Todo: check for obsolete code
    relaxed: boolean;
    showExitToLobby: boolean;
}


export const sharedGameWrapperState = {
    // Enabling this makes the timer decrement itself each second & also triggers fetchGameTime()
    enableTimers: true,

    // Usage: fetchGameList(), fetchUserData()
    // Basically whether you want to use temporary data or not.
    useTempData: false,

    logSocketEvents: false,
    logBaccaratScanEvent: false,
    logDTScanEvent: false,
    logNNScanEvent: false,
    logLottoScanEvent: false,

    // Chip selector active value
    chipValue: 1,

    insufficientBalance: false,
};
